/**
 * セクショングループ管理者詳細ページ専用i18n定数
 */

export const DISTRIBUTOR_AGENT_I18N = {
  // ステータス
  status: {
    active: $localize`:@@distributorAgent.adminDetails.status.active:有効`,
    inactive: $localize`:@@distributorAgent.adminDetails.status.inactive:無効`,
  },

  // 性別オプション
  sex: {
    male: $localize`:@@distributorAgent.adminDetails.sex.male:男性`,
    female: $localize`:@@distributorAgent.adminDetails.sex.female:女性`,
    other: $localize`:@@distributorAgent.adminDetails.sex.other:その他`,
  },

  // ボタン
  button: {
    close: $localize`:@@distributorAgent.adminDetails.button.close:閉じる`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@distributorAgent.adminDetails.validation.checkFields:各フィールドの内容を再度確認してください`,
    selectAtLeastOneRole: $localize`:@@distributorAgent.adminDetails.validation.selectAtLeastOneRole:権限を最低ひとつ選択してください。`,
    passwordMismatch: $localize`:@@distributorAgent.adminDetails.validation.passwordMismatch:２つのパスワードが一致しません。`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@distributorAgent.adminDetails.message.updateSuccess:管理者の情報を更新しました。`,
    updateError: $localize`:@@distributorAgent.adminDetails.message.updateError:管理者の情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    inviteSuccess: $localize`:@@distributorAgent.adminDetails.message.inviteSuccess:管理者の招待メールを送信しました。`,
    inviteError: $localize`:@@distributorAgent.adminDetails.message.inviteError:管理者の招待に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    createSuccess: $localize`:@@distributorAgent.adminDetails.message.createSuccess:管理者を作成しました。`,
    createError: $localize`:@@distributorAgent.adminDetails.message.createError:管理者の作成に失敗しました。`,
  },
} as const;

export type distributorAgentDetailsI18n = typeof DISTRIBUTOR_AGENT_I18N;
